// Version : 0.0.2
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last Add : 'REMOVE UNUSED LINES'
// Modified Date : 06/12/2025
const GoldLoanDisbursementTypes = {
	/** ***************** FETCH  GOLD LOAN INDEX BASED GROUP LIST START *********************** */
	GOLD_LOAN_INDEX_DISBURSEMENT_START: 'gold_loan_index_disbursement_start',
	GOLD_LOAN_INDEX_DISBURSEMENT_SUCCESS: 'gold_loan_index_disbursement_success',
	GOLD_LOAN_INDEX_DISBURSEMENT_FAILURE: 'gold_loan_index_disbursement_failure',
	GOLD_LOAN_INDEX_DISBURSEMENT_RESPONSE_RESET_START:
		'gold_loan_index_disbursement_response_reset_start',
	GOLD_LOAN_INDEX_DISBURSEMENT_RESPONSE_CHANGED: 'gold_loan_index_disbursement_response_changed',
	/** ***************** FETCH GOLD LOAN INDEX BASED GROUP LIST END *********************** */

	/** ***************** FETCH GOLD LOAN INDEX BASED GROUP LIST START *********************** */
	GOLD_LOAN_INDEX_DISBURSEMENT_LIST_START: 'gold_loan_index_disbursement_list_start',
	GOLD_LOAN_INDEX_DISBURSEMENT_LIST_SUCCESS: 'gold_loan_index_disbursement_list_success',
	GOLD_LOAN_INDEX_DISBURSEMENT_LIST_FAILURE: 'gold_loan_index_disbursement_list_failure',
	GOLD_LOAN_INDEX_DISBURSEMENT_LIST_RESPONSE_RESET_START:
		'gold_loan_index_disbursement_list_response_reset_start',
	GOLD_LOAN_INDEX_DISBURSEMENT_LIST_RESPONSE_CHANGED:
		'gold_loan_index_disbursement_list_response_changed',
	/** ***************** FETCH GOLD LOAN INDEX BASED GROUP LIST END *********************** */

	/** ***************** UPDATE GOLD LOAN DISBURSEMENT  START *********************** */
	UPDATE_GOLD_LOAN_DISBURSEMENT_START: 'update_gold_loan_disbursement_start',
	UPDATE_GOLD_LOAN_DISBURSEMENT_SUCCESS: 'update_gold_loan_disbursement_success',
	UPDATE_GOLD_LOAN_DISBURSEMENT_FAILURE: 'update_gold_loan_disbursement_failure',
	UPDATE_GOLD_LOAN_DISBURSEMENT_RESPONSE_RESET_START:
		'update_gold_loan_disbursement_response_reset_start',
	UPDATE_GOLD_LOAN_DISBURSEMENT_RESPONSE_CHANGED:
		'update_gold_loan_disbursement_response_changed',
	/** ***************** UPDATE GOLD LOAN DISBURSEMENT END *********************** */
};
export default GoldLoanDisbursementTypes;
